/**
 * items.ts — Typed item data with lookup by ID.
 */

import type { Item } from './types';
import itemData from './items.json';

/** All items as a typed record (keyed by item ID). */
export const itemRecord: Record<string, Item> = itemData as unknown as Record<string, Item>;

/** All items as a typed array. */
export const items: Item[] = Object.values(itemRecord);

/** Get an item by ID, or undefined if not found. */
export function getItem(id: string): Item | undefined {
  return itemRecord[id];
}

/** Get all item IDs. */
export function getItemIds(): string[] {
  return Object.keys(itemRecord);
}
